import { useIntl } from "react-intl";
import { SUPPORTED_LOCALES, localeDisplayName } from "../i18n/locales.js";
import { useChangeLocale, useLocale } from "../i18n/hooks.js";
import { Icon } from "./Icon.jsx";

/** Compact globe + select. Saves to the profile only when signed in. */
export function LanguageSwitcher({ saveToProfile = true, className = "" }) {
  const intl = useIntl();
  const locale = useLocale();
  const change = useChangeLocale({ saveToProfile });
  return (
    <label className={`lang-switch ${className}`}>
      <Icon name="globe" size={16} />
      <span className="visually-hidden">{intl.formatMessage({ id: "topbar.language" })}</span>
      <select value={locale} onChange={(e) => change(e.target.value)}>
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {localeDisplayName(l.code)}
          </option>
        ))}
      </select>
    </label>
  );
}
